/**
 * 将可能是 `Asset://<id>` 引用的 URL 解析为可直接下载的真实 HTTP URL。
 * 自助审核系统已下线：Asset:// 引用只能通过节点 data 里缓存的
 * `assetPreviewUrl`（历史提审时保存）解析，缺失预览则返回 null。
 *
 * @param url            节点里保存的 url（可能是 Asset://<id>）
 * @param assetPreviewUrl 节点 data 中缓存的真实预览 URL（可选）
 */
export function resolveDownloadableUrl(
  url: string | undefined,
  assetPreviewUrl: string | undefined,
): string | null {
  if (!url) return null;
  if (!url.startsWith('Asset://')) return url;
  return assetPreviewUrl || null;
}
